/**
 * PD-6616: Show gluten-free and vegetarian icons on the restaurant list card.
 *
 * @see https://firsttable.atlassian.net/browse/PD-6616
 * @see https://app.growthbook.io/features/pd-6616-dietary-badges-on-restaurant-list
 * @see https://app.growthbook.io/experiment/exp_19g6dmvq157ub
 */
export const PD6616_DIETARY_BADGES_FLAG = 'pd-6616-dietary-badges-on-restaurant-list';
